module.exports = __webpack_public_path__ + "static/media/con_img_02.8f48c083.png";